<template>
  <div :style="`height:${tableHeight}px`">
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      height="100%"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="selectItem.taskType==='PERSON_IMPORT'||selectItem.taskType=== 'PERSON_IMPORT_HEADER'"
        label="序号"
        width="50"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectItem.taskType==='ZQXY_PERSON_PULL'"
        type="selection"
        width="55"
        align="center"
      />
      <el-table-column
        v-if="selectItem.taskType==='ZQXY_PERSON_PULL'||selectItem.taskType=== 'PERSON_IMPORT_HEADER'"
        width="80"
        label="照片"
        align="center"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.personPhotoPath"
            :preview-src-list="[scope.row.personPhotoPath]"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectItem.taskType=== 'PERSON_IMPORT_HEADER'"
        prop="photoName"
        label="照片名称"
        align="center"
      />
      <el-table-column
        v-if="selectItem.taskType!== 'PERSON_IMPORT_HEADER'&&selectItem.taskType!=='VERIFY_DEVICE_PULL_PERSON'&&selectItem.taskType!=='WHITELIST_IMPORT'"
        prop="personName"
        label="姓名"
        align="center"
      />
      <template v-if="selectItem.taskType=== 'VERIFY_DEVICE_PULL_PERSON'">
        <el-table-column
          label="序号"
          width="50"
        >
          <template slot-scope="scope">
            {{ scope.$index+1 }}
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="照片"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="scope.row.personPhotoPath"
              :preview-src-list="[scope.row.personPhotoPath]"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="gulUserName"
          label="姓名"
          align="center"
        />
        <el-table-column
          prop="devicePersonCode"
          label="设备人员编码"
          align="center"
        />
        <el-table-column
          prop="personType"
          label="人员类型"
          align="center"
        >
          <template slot-scope="scope">
            {{ personType[scope.row.personType]&&personType[scope.row.personType].label }}
          </template>
        </el-table-column>
        <el-table-column
          prop="gudRespTime"
          label="处理时间"
          align="center"
        />
        <el-table-column
          width="80"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <div :class="{green:scope.row.gudDealResult,red:!scope.row.gudDealResult}">
              {{ scope.row.gudDealResult?'成功':'失败' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="gudDealMsg"
          label="结果"
          align="center"
        />
      </template>

      <el-table-column
        v-if="selectItem.taskType!== 'PERSON_IMPORT_HEADER'&&selectItem.taskType!=='VERIFY_DEVICE_PULL_PERSON'&&selectItem.taskType!=='WHITELIST_IMPORT'"
        prop="idcardNumber"
        width="150"
        label="身份证号码"
        align="center"
      />

      <el-table-column
        v-if="selectItem.taskType==='ZQXY_PERSON_PULL'"
        prop="companyName"
        label="所属企业"
        align="center"
      />
      <el-table-column
        v-if="selectItem.taskType!== 'PERSON_IMPORT_HEADER'&&selectItem.taskType!== 'BLACKLIST_IMPORT'&&selectItem.taskType!=='VERIFY_DEVICE_PULL_PERSON'&&selectItem.taskType!=='BANK_CARD_IMPORT'&&selectItem.taskType!=='WHITELIST_IMPORT'"
        prop="teamName"
        label="班组"
        align="center"
      />
      <el-table-column
        v-if="selectItem.taskType!== 'PERSON_IMPORT_HEADER'&&selectItem.taskType!== 'BLACKLIST_IMPORT'&&selectItem.taskType!=='VERIFY_DEVICE_PULL_PERSON'&&selectItem.taskType!=='WHITELIST_IMPORT'&&selectItem.taskType!=='BANK_CARD_IMPORT'"
        prop="workerTypeName"
        label="工种"
        align="center"
      />
      <el-table-column
        v-if="selectItem.taskType==='PERSON_IMPORT'"
        prop="jobNumber"
        label="工号"
        align="center"
      />
      <el-table-column
        v-if="selectItem.taskType==='PERSON_IMPORT'"
        width="70"
        label="照片"
        align="center"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.personPhotoPath"
            :preview-src-list="[scope.row.personPhotoPath]"
          />
        </template>
      </el-table-column>
      <template v-if="selectItem.taskType==='BANK_CARD_IMPORT'">
        <el-table-column
          prop="bankName"
          label="开户银行"
          align="center"
        />
        <el-table-column
          prop="cardNumber"
          label="银行卡号"
          align="center"
        />
        <el-table-column
          prop="bankDeposit"
          label="开户行"
          align="center"
        />
      </template>
      <template v-if="selectItem.taskType==='BLACKLIST_IMPORT'">
        <el-table-column
          prop="eventDescription"
          label="事件描述"
          align="center"
        />
        <el-table-column
          prop="eventTime"
          label="事件时间"
          align="center"
        />
        <el-table-column
          prop="eventPlace"
          label="事件地点"
          align="center"
        />
      </template>
      <el-table-column
        v-if="selectItem.taskType==='PERSON_IMPORT'||selectItem.taskType=== 'BLACKLIST_IMPORT'||selectItem.taskType==='BANK_CARD_IMPORT'||selectItem.taskType=== 'PERSON_IMPORT_HEADER'"
        prop="createTime"
        width="140"
        label="处理时间"
        align="center"
      />
      <el-table-column
        v-if="selectItem.taskType==='PERSON_IMPORT'||selectItem.taskType=== 'BLACKLIST_IMPORT'||selectItem.taskType==='BANK_CARD_IMPORT'||selectItem.taskType=== 'PERSON_IMPORT_HEADER'"
        prop="recordStatus"
        width="80"
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          <div :class="{green:scope.row.recordStatus,red:!scope.row.recordStatus}">
            {{ scope.row.recordStatus?'成功':'失败' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectItem.taskType==='PERSON_IMPORT'||selectItem.taskType==='BLACKLIST_IMPORT'||selectItem.taskType==='BANK_CARD_IMPORT'||selectItem.taskType=== 'PERSON_IMPORT_HEADER'"
        prop="recordContent"
        label="信息"
        align="center"
      />
      <template v-if="selectItem.taskType==='WHITELIST_IMPORT'">
        <el-table-column
          prop="licensePlate"
          label="车牌号"
          align="center"
        />
        <el-table-column
          prop="wtypeCn"
          label="车牌类型"
          align="center"
        />
        <el-table-column
          prop="colorCn"
          label="车牌颜色"
          align="center"
        />
        <el-table-column
          prop="carType"
          label="车辆类型"
          align="center"
        >
          <template slot-scope="scope">
            {{ carType[scope.row.carType]&&carType[scope.row.carType].label }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mcName"
          label="车队名称"
          align="center"
        />
        <el-table-column
          prop="effectTime"
          label="生效时间"
          align="center"
        />
        <el-table-column
          prop="expirationTime"
          label="过期时间"
          align="center"
        />
        <el-table-column
          prop="equipmentName"
          label="通过设备"
          align="center"
        />
        <el-table-column
          prop="remark"
          label="车辆备注"
          align="center"
        />
        <el-table-column
          prop="createTime"
          label="处理时间"
          align="center"
        />
        <el-table-column
          width="80"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <div :class="{green:scope.row.status,red:!scope.row.status}">
              {{ scope.row.status?'成功':'失败' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="信息"
          align="center"
        />
      </template>
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { carType } from '@/views/device/license-plate-recognition/white-list/config'
import { personType } from '@/const/index'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 100
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      checkList: [],
      carType,
      personType
    }
  },
  computed: {
    ...mapState({})
  },
  methods: {
    handleSelectionChange(e) {
      this.$emit('handleSelectionChange', e)
    },
    handleButton(emitName, item, index) {
      this.$emit(emitName, item, index)
    },
    getInstance() {
      return this.$refs.multipleTable
    }
  }
}
</script>

<style scoped lang="scss">
.checkboxList {
  display: flex;
  flex-wrap: wrap;
  .el-checkbox {
    width: 50%;
    margin-right: 0;
  }
}
.operation {
  display: inline-block;
  cursor: pointer;
}
</style>
